/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Responsive } from 'common/components';
import { CSSTransition } from 'react-transition-group';
import _ from 'lodash';
import { Header, RabbiCredit } from 'client/components/common';
import * as css from './ClosedVotes.scss';

export default class ResultPage extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		isStarted: PropTypes.bool.isRequired,
		in: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		className: '',
	};

	state = {
		animationState: '',
	};

	async componentDidMount() {
		window.addEventListener('resize', this.onWindowResize);
	}

	componentDidUpdate() {}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
	}

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	renderTitle = () => {
		// const TARGET_DATE_UTC = new Date('2025-12-30T00:00:00.000Z');
		// const now = new Date();
		const isVotesClosed = true; // now >= TARGET_DATE_UTC;

		return (
			<>
				{isVotesClosed ? (
					<p className={css.title}>ההצבעה נסגרה</p>
				) : (
					<p className={css.title}>
						{Responsive.isMatching(Responsive.DESKTOP) && (
							<>
								ניתן להצביע למצעד
								<br />
								הבינלאומי השנתי רק פעם אחת.
								<br />
								תודה רבה על השתתפותכם!
							</>
						)}
						{Responsive.isMatching(Responsive.MOBILE) && (
							<>ניתן להצביע למצעד הבינלאומי השנתי רק פעם אחת. תודה רבה על השתתפותכם!</>
						)}
					</p>
				)}
			</>
		);
	};

	render() {
		const { className, isStarted } = this.props;
		const { animationState } = this.state;
		const cssTProps = _.omit(this.props, ['className', 'isStarted', 'staticContext', 'history']);

		// const closeTitle = 'ההצבעה נסגרה';
		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div className={classNames(css.closedVotes, isStarted && css[animationState], className)}>
					<Header className={css.header} isHiddenOnMain />
					{Responsive.isMatching(Responsive.DESKTOP) && (
						<div
							className={css.genearlBg}
							style={{ backgroundImage: 'url(/assets/client/imgs/general-bg.png)' }}
						></div>
					)}

					{Responsive.isMatching(Responsive.MOBILE) && (
						<div
							className={css.genearlBgMobile}
							style={{ backgroundImage: 'url(/assets/client/imgs/main-bg-m.png)' }}
						></div>
					)}
					<div className={css.info}>
						{this.renderTitle()}
						<p className={css.desciption}>
							המצעד ישודר בגלגלצ ב-31 בדצמבר (יום רביעי) בין השעות 18:00-15:00
						</p>
					</div>
					{/* <MakoAnalytics pageId={MAKO_ANALYTICS_PAGE_IDS.MAIN()} /> */}
					<RabbiCredit className={css.rabbiCredit} theme="light" />
				</div>
			</CSSTransition>
		);
	}
}
